import { RECEIVE_ACTIVATION, INVALIDATE_ACTIVATION } from '../actions/activated';
function reducer(state = false, action) {
    switch (action.type) {
        case RECEIVE_ACTIVATION:
            return action.activated;
        case INVALIDATE_ACTIVATION:
            return false;
        default:
            return state;
    }
}

export default reducer;
